import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, forwardRef, Input, OnInit, ViewChild} from '@angular/core';
import {CustomFormComponent} from '../../classes/custom-form-component';
import {NG_VALIDATORS, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
    selector: 'password-input',
    templateUrl: './password-input.component.html',
    styleUrls: ['./password-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PasswordInputComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => PasswordInputComponent),
            multi: true,
        },
    ],
})
export class PasswordInputComponent extends CustomFormComponent<string> implements OnInit {
    @ViewChild('inputEl', {static: true}) $inputEl: ElementRef<HTMLInputElement>;
    @Input() autoComplete: boolean;

    fieldTextType = false;

    constructor($el: ElementRef, cd: ChangeDetectorRef) {
        super($el, cd);
    }

    get value() {
        return this.internalValue || '';
    }

    ngOnInit() {
        this.initInputValue('autoComplete', true);
    }

    isInvalid() {
        return !this.getInput().validity.valid;
    }

    getInput() {
        return this.$inputEl.nativeElement;
    }

    onChange() {
        this.invokeChangeCallback(this.getInput().value);
    }

    onBlur() {
        this.invokeTouchCallback();
        this.touched = true;
    }

    isFieldTextType() {
        this.fieldTextType = !this.fieldTextType;
    }
}
